<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/IHtw9T/tc-custom/9781488038341.jpg?1728851686518" alt="This image is the cover for the book Ghost Walk, Harrison Investigation"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ghost Walk, Harrison Investigation
      </h1>
      <p class="bookDescription body article font2">
        <b>A paranormal investigator comes to the aid of a frightened New Orleans businesswoman in this “unrelentingly suspenseful” romantic thriller (<i>Booklist</i>).</b><br/><br/>Nikki DuMonde’s newest employee is standing at the end of her bed at four o’clock in the morning begging for help. It’s a joke, right? Besides, as manager of a successful New Orleans haunted-tour company, Nikki doesn’t scare easily. But in the light of day, harsh reality sets in as a police officer informs her that Andy was brutally murdered—at the exact time Nikki swears the distraught woman was in her room.<br/><br/>No one believes her except for Brent Blackhawk, a paranormal investigator desperately trying to forget his tragic past. Half Irish, half Lakota—and able to communicate with the dead—Brent is used to living in two worlds. But when he realizes the ghost of a slain government agent is also trying to reach out to Nikki, he knows that she, too, must listen to the dead . . . if she wants to keep living.<br/><br/>“There are good reasons for Graham’s steady standing as a bestselling author. Here her perfect pacing keeps readers riveted as they learn fascinating tidbits of New Orleans history. The paranormal elements are integral to the unrelentingly suspenseful plot, the characters are likable, the romance convincing, and, in the wake of Hurricane Katrina, Graham’s atmospheric depiction of a lost city is especially poignant.” —<i>Booklist</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Heather Graham
      </h2>
      
      <p class="authorDescription body article">Heather Graham (b. 1953) is a bestselling author of more than 150 romance, suspense, and historical novels that have sold seventy-five million copies worldwide. Raised in Florida, Graham went to college for theater arts, and spent several years acting, singing, and bartending before she devoted herself to writing. Her first novel, <i>When Next We Love</i>, was published in 1982. Although she became famous as an author of romance novels, Graham has since branched out into supernatural horror, historical fiction, and suspense, with titles such as <i>Tall, Dark, and Deadly </i>(1999), <i>Long, Lean, and Lethal </i>(2000), and<i> Dying to Have Her </i>(2001). In 2003 the Romance Writers of America, whose Florida chapter Graham founded, granted her a lifetime achievement award. She lives, writes, and scuba dives in Florida with her husband and five children. <BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5c58ac68